import React from 'react';
import { Link } from 'react-router-dom';

export default function LatestNews({ data }) {
  return (
    <section className="latest-news">
      <div className="container">
        <div className="latest-news-content">
          <div className="latest-news-left">
            <div className="candy">Get The Latest News</div>
            <div className="latest-title">AI X MARKETING</div>
            <div className="latest-description">
              Be at the forefront of AI and Marketing,
              Our platform is where technology meets creativity.
              Read about the latest industry developments.
            </div>
            <div className="more-info">
              <Link to="/blog" className="nav-link">more blog posts</Link>
            </div>
          </div>
          <div className="latest-news-right">
            {data.map((blogItem) => (
              <div className="blog-article-row" key={blogItem.id}>
                <div className="blog-list">
                  <div className="blog-image">
                    <img src={blogItem.image} alt={blogItem.title} />
                  </div>
                  <div className="blog-details">
                    <div className="info">
                      <span>
                        <i>{blogItem.date.day}</i> {blogItem.date.month}
                      </span>
                      <span> / </span>
                      <span>{blogItem.author}</span>
                    </div>
                    <div className="blog-article-title">
                      <h5>
                        <Link to={`/blog/${blogItem.slug}`}>
                          {blogItem.title}
                        </Link>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
